const protectedRoutePatterns = [
  /\/complete-profile\b/,
  /\/perfil\b/,
  /\/proyectos\/new\b/,
  /\/proyectos\/[^/]+\/edit\b/,
  /\/developer\/proyectos\/new\b/,
  /\/developer\/proyectos\/[^/]+\/edit\b/,
];

export const SESSION_ACTIVITY_EVENT = 'profunding:session-activity';

export function isSessionIdleSuppressed() {
  if (typeof document === 'undefined') return false;

  const active = document.activeElement;
  if (
    active?.closest?.(
      'form, input, textarea, select, [contenteditable="true"], [role="dialog"], dialog, [data-modal="true"]',
    )
  ) {
    return true;
  }

  if (
    document.querySelector(
      '[role="dialog"], dialog, [data-modal="true"], [class*="modal"], [class*="Modal"], [class*="overlay"], [class*="Overlay"]',
    )
  ) {
    return true;
  }

  const path = window.location.pathname;
  return protectedRoutePatterns.some((pattern) => pattern.test(path));
}

export function markSessionActivity() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(SESSION_ACTIVITY_EVENT));
}
